/* Anavadhya — header behaviour: menu panels, the search pop-up and the mobile drawer.
   The header works without this file; this adds click-to-open panels, Escape to close,
   and opens the theme's search pop-up instead of going to the search page. */
(function () {
  'use strict';

  function init(header) {
    if (header.__anvReady) return;
    header.__anvReady = true;

    var items = header.querySelectorAll('[data-anv-dropdown]');

    function closeAll(except) {
      items.forEach(function (item) {
        if (item === except) return;
        item.classList.remove('is-open');
        var btn = item.querySelector('[data-anv-dropdown-toggle]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }

    items.forEach(function (item) {
      var btn = item.querySelector('[data-anv-dropdown-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        closeAll(item);
        item.classList.toggle('is-open', open);
        item.classList.toggle('is-closed', !open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      item.addEventListener('mouseleave', function () { item.classList.remove('is-closed'); });
    });

    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) closeAll(null);
    });

    // Search: open the theme's pop-up when it's there; otherwise the link goes to /search.
    header.querySelectorAll('[data-anv-search-open]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var modal = document.getElementById('search-modal');
        if (modal && typeof modal.showDialog === 'function') {
          e.preventDefault();
          var drawer = header.querySelector('[data-anv-drawer]');
          if (drawer && drawer.open) drawer.open = false;
          modal.showDialog();
        }
      });
    });

    // Mobile drawer: sit just under the header and stop the page scrolling behind it.
    var drawer = header.querySelector('[data-anv-drawer]');
    if (drawer) {
      drawer.addEventListener('toggle', function () {
        if (drawer.open) {
          header.style.setProperty('--anv-hd-bottom', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
          var panel = drawer.querySelector('.anv-hd__drawer-panel');
          if (panel) panel.style.setProperty('--anv-hd-bottom', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
        }
        document.documentElement.classList.toggle('anv-lock', drawer.open);
      });
      window.matchMedia('(min-width: 990px)').addEventListener('change', function (e) {
        if (e.matches && drawer.open) drawer.open = false;
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openItem = header.querySelector('[data-anv-dropdown].is-open');
      if (openItem) {
        closeAll(null);
        var btn = openItem.querySelector('[data-anv-dropdown-toggle]');
        if (btn) btn.focus();
      }
      if (drawer && drawer.open) {
        drawer.open = false;
        var summary = drawer.querySelector('summary');
        if (summary) summary.focus();
      }
    });
  }

  function start() {
    document.querySelectorAll('[data-anv-header]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
